var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCoupon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.25 0.25H1.75C1.41848 0.25 1.10054 0.381696 0.866116 0.616117C0.631696 0.850537 0.5 1.16848 0.5 1.5V6.5H1.61625C2.86125 6.5 4.01625 7.35125 4.21625 8.58C4.27718 8.9388 4.25908 9.30657 4.16321 9.65765C4.06734 10.0087 3.89601 10.3347 3.66118 10.6127C3.42635 10.8907 3.13368 11.1142 2.80358 11.2674C2.47349 11.4207 2.11393 11.5 1.75 11.5H0.5V16.5C0.5 16.8315 0.631696 17.1495 0.866116 17.3839C1.10054 17.6183 1.41848 17.75 1.75 17.75H24.25C24.5815 17.75 24.8995 17.6183 25.1339 17.3839C25.3683 17.1495 25.5 16.8315 25.5 16.5V11.5H24.25C23.8861 11.5 23.5265 11.4207 23.1964 11.2674C22.8663 11.1142 22.5736 10.8907 22.3388 10.6127C22.104 10.3347 21.9327 10.0087 21.8368 9.65765C21.7409 9.30657 21.7228 8.9388 21.7837 8.58C21.9837 7.35125 23.1387 6.5 24.3837 6.5H25.5V1.5C25.5 1.16848 25.3683 0.850537 25.1339 0.616117C24.8995 0.381696 24.5815 0.25 24.25 0.25ZM11.75 15.25H9.25V12.75H11.75V15.25ZM11.75 10.25H9.25V7.75H11.75V10.25ZM11.75 5.25H9.25V2.75H11.75V5.25Z",
    fill: "#004A2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoupon);
export default __webpack_public_path__ + "static/media/IconCoupon.20167cdd2325c2d59538c825f1e74ea0.svg";
export { ForwardRef as ReactComponent };